import React from 'react';

import { List, Modal, Text, Title } from '@mantine/core';
import { STRIPE_TERMINAL_S700_URL } from 'utils/external-resources';

interface StripeTerminalReaderInstructionsModalProps {
  opened: boolean;
  onClose: () => void;
  onRegisterClick: () => void;
}

const StripeTerminalReaderInstructionsModal = ({
  opened,
  onClose,
  onRegisterClick,
}: StripeTerminalReaderInstructionsModalProps): JSX.Element => (
  <Modal
    opened={opened}
    onClose={onClose}
    title={
      <Title order={3} align='center'>
        How to enable in person payments?
      </Title>
    }
    centered
    size='lg'
    padding='xl'
  >
    <List type='ordered' spacing='xl' size='lg'>
      <List.Item>
        Purchase S700 card reader from Stripe. Purchase reader{' '}
        <Text span color='kiloBlue' component='a' href={STRIPE_TERMINAL_S700_URL} target='_blank'>
          here
        </Text>
        .
      </List.Item>
      <List.Item>
        When you receive your reader go ahead and register it.{' '}
        <Text span color='kiloBlue' onClick={onRegisterClick} sx={{ cursor: 'pointer' }}>
          Register Reader
        </Text>
        .
      </List.Item>
      <List.Item>
        Once you register your reader you will be able to start receiving in person payments on the package,
        retail and fees checkout flows.{' '}
      </List.Item>
    </List>
  </Modal>
);

export default StripeTerminalReaderInstructionsModal;
